import { render, staticRenderFns } from "./KeuanganAnggota.vue?vue&type=template&id=b51f9230"
import script from "./KeuanganAnggota.vue?vue&type=script&lang=js"
export * from "./KeuanganAnggota.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports